export const getViewLink = (projectKey: string, viewSlug: string) =>
	`/jira/polaris/projects/${projectKey}/ideas/view/${viewSlug}`;
